import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { isInInvervalBound } from '../helpers/code-helper';
import { journeyDataDefault } from '../interfaces/journeyDataDefault';
import { SetStates, SetSubStates, rangeHighRiskEndorsment, rangeNormalEndorsment, rangeVeryHighRiskEndorsment } from '../shared/states';
import { TypeOfValidation } from '../interfaces/enums';
import { WINDOW } from 'src/app/utils/window';

@Injectable({
  providedIn: 'root',
})
export class StepService {
  /* Estado */
  state = new BehaviorSubject('');

  /* general tabs */
  step = new BehaviorSubject(0);

  /* inter tabs */
  subStep = new BehaviorSubject(0);

  /* inter tabs */
  tabNumber = new BehaviorSubject(1);

  /* Para habilitar o deshabilitar algo */
  loading = new BehaviorSubject(false);

  destroyBtn = new BehaviorSubject(false);

  loadingCarSelected = new BehaviorSubject(false);

  isRecalculated = new BehaviorSubject(false);

  data: any = journeyDataDefault;

  screenSize = new BehaviorSubject(this.window.innerWidth);

  berauValid: boolean = true;

  identidadValid: boolean = true;

  docsValid: boolean = false;

  solicitudValid: boolean = false;

  showImputRequired = new BehaviorSubject(false);

  isPriceChanged = new Subject<boolean>();

  constructor(@Inject(WINDOW) private window: Window){}

  calculateStep(state: string) {
    state = this.fixState(state);

    const excludeSteps = ['E4', 'E11', 'E33', 'E41'];

    if (excludeSteps.includes(state)) {
      this.step.next(0);
      this.subStep.next(1);
      return;
    }

    for (const [index, states] of SetStates.entries()) {
      if (states.includes(state)) {
        this.step.next(index);
        this.subStep.next(this.calculateSubStep(SetSubStates[index], state));
        return;
      }
    }
  }

  fixState(state: string) {
    return state === 'E23' && this.data.status !== 'Finalizado' ? 'E22' : state;
  }

  calculateSubStep(subConjuntos: string[][], state: string) {
    return subConjuntos.findIndex((ele) => ele.includes(state));
  }

  isDavinciFinishedBerau() {
    const states = ['E7', 'E14', 'E36', 'E44'];
    return (
      states.includes(this.data.step!) && this.data.status !== 'En Proceso'
    );
  }

  isDavinciNotFinishedBerau() {
    const states = ['E7', 'E14', 'E36', 'E44'];
    return (
      states.includes(this.data.step!) && this.data.status === 'En Proceso'
    );
  }

  updateData(data: any) {
    this.data = { ...this.data, ...data };
  }

  updateDataAndScreen(data: any) {
    console.log("updateDataAndScreen:" + data)
    this.data = { ...this.data, ...data };
    this.state.next(this.data.step!);
  }

  getDataMethod() {

    const rangesEndorsment = [
      { step: 'E11', range: rangeNormalEndorsment },
      { step: 'E33', range: rangeHighRiskEndorsment },
      { step: 'E41', range: rangeVeryHighRiskEndorsment },
    ];

    if (isInInvervalBound(this.data.step!)) {
      const currentEndorsment = rangesEndorsment.find((item) => item.range.includes(this.data.step));
      return this.data?.[currentEndorsment!.step]?.data;
    }

    return this.data.E4!.data;
  }

  getMethodOfUser() {

    const rangesEndorsment = [
      { step: 'E11', range: rangeNormalEndorsment },
      { step: 'E33', range: rangeHighRiskEndorsment },
      { step: 'E41', range: rangeVeryHighRiskEndorsment },
    ];

    if (isInInvervalBound(this.data.step!)) {
      const currentEndorsment = rangesEndorsment.find((item) => item.range.includes(this.data.step));
      return this.data?.[currentEndorsment!.step]?.data?.sendMethod || TypeOfValidation.NONE;
    }
    return this.data.E4!.data!.sendMethod!;
  }

  isDavinciFinishedRisk() {
    const states = ['E9', 'E16', 'E38', 'E46'];
    return (
      states.includes(this.data.step!) && this.data.status !== 'En Proceso'
    );
  }

  isNotDavinciFinishedRisk() {
    const states = ['E9', 'E16', 'E38', 'E46'];
    return (
      states.includes(this.data.step!) && this.data.status === 'En Proceso'
    );
  }

  getParamsProduct() {
    const quoterId = this.data.quoterId!;
    const { concept, period } = this.data.product;
    return { quoterId, concept: concept.toLowerCase(), period };
  }

  getInfoId() {
    return isInInvervalBound(this.data.step!)
      ? this.data.clientInfoIdEndorsment
      : this.data.clientInfoId;
  }

  getExecutionStatusRisk() {

    const rangesEndorsment = [
      { step: 'E16', range: rangeNormalEndorsment },
      { step: 'E38', range: rangeHighRiskEndorsment },
      { step: 'E46', range: rangeVeryHighRiskEndorsment },
    ];

    if (isInInvervalBound(this.data.step!)) {
      const currentEndorsment = rangesEndorsment.find((item) => item.range.includes(this.data.step));
      return this.data[currentEndorsment!.step].data.execution_status;
    }
    return this.data.E9!.data!.execution_status;
  }

  needEndorsment() {
    return this.data.E9!.data!.jointly_bound === 'YES';
  }

  getTypeClient(state: string) {

    const rangesEndorsment = [
      { step: 'E16', range: rangeNormalEndorsment },
      { step: 'E38', range: rangeHighRiskEndorsment },
      { step: 'E46', range: rangeVeryHighRiskEndorsment },
    ];

    let clientType = null;

    if (isInInvervalBound(state)) {
      const currentEndorsment = rangesEndorsment.find((item) => item.range.includes(state));
      clientType = this.data[currentEndorsment!.step].data.client_type;
    } else {
      clientType = this.data.E9!.data!.client_type!;
    }

    return (clientType !== null)
      ? clientType.split(':')[1].trim()
      : 'R';
  }

  isTypeR(state: string) {
    let clientType = this.getTypeClient(state);
    return clientType === 'R';
  }

  isFlow(flowType: string) {

    flowType = flowType.toUpperCase();
    if (
      (this.data.flowType === '' || this.data.flowType === undefined) &&
      flowType === 'A'
    ) {
      return true;
    }
    return flowType === this.data.flowType;
  }


}
